import React from 'react';
import { BookOpen, Sparkles } from 'lucide-react';
import { SectionHeader } from '../ui/SectionHeader';
import { tradingBasics } from '../../data/education/basics';
import { useTradingBasics } from '../../hooks/useEducationContent';
import { useExchangeRates } from '../../hooks/useExchangeRates';

export function TradingBasics() {
  const { data: rates } = useExchangeRates();
  const { data: aiBasics, isLoading: basicsLoading } = useTradingBasics(rates);

  const displayBasics = aiBasics && aiBasics.length > 0 ? aiBasics : tradingBasics;
  const isAIContent = aiBasics && aiBasics.length > 0;

  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden">
      <div className="relative h-48">
        <img
          src="https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f"
          alt="Trading education and learning"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-blue-900/80 to-blue-800/60" />
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-center text-white">
            <BookOpen className="h-12 w-12 mx-auto mb-2" />
            <h2 className="text-2xl font-bold">Trading Basics</h2>
          </div>
        </div>
      </div>
      <div className="p-6">
        {isAIContent && (
          <div className="mb-4 flex items-center gap-2 text-sm text-emerald-600 bg-emerald-50 px-3 py-2 rounded-lg">
            <Sparkles className="h-4 w-4" />
            <span>AI-generated content based on current market conditions</span>
          </div>
        )}

        {basicsLoading ? (
          <div className="grid gap-6">
            {[1, 2, 3, 4, 5].map((i) => (
              <div key={i} className="bg-gray-50 p-4 rounded-lg animate-pulse">
                <div className="h-5 bg-gray-200 rounded w-3/4 mb-2"></div>
                <div className="h-4 bg-gray-200 rounded w-full mb-1"></div>
                <div className="h-4 bg-gray-200 rounded w-5/6"></div>
              </div>
            ))}
          </div>
        ) : (
          <div className="grid gap-6">
            {displayBasics.map((item, index) => (
              <div key={index} className="bg-gray-50 p-4 rounded-lg border-l-4 border-blue-500">
                <h3 className="font-semibold text-lg mb-2">{item.title}</h3>
                <p className="text-gray-600">{item.content}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}